import { Button, Grid, Paper } from "@mui/material"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import { gridSize, gridSizeMdLg4, TipoProductoEnumChoice, useTableColumnsProducto, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { CustomAutocomplete, GeneralTable, SearchComponente } from "@/shared/components/ui";
import { useForm } from "react-hook-form";
import { useFetchCategoryProduct, usefetchCostos, useFetchGastos, useFetchProductos } from "@/shared/actions/erp";
import { CATEGORYPRODUCT } from "@/shared/interfaces/erp/inventario";

import useTableColumnsRegistroFacturas from "../../hook/useTableColumnsRegistroFacturas";
type ModalProductoComponenteProps = {
  onChange?: (e: any) => void
  //ubicacion?: string
}
export default function ModalProductoComponete({ onChange }: ModalProductoComponenteProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [catalogo, setCatalogo] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')

  const {
    columnsSelectProductoModal
  } = useTableColumnsProducto()
  const {
    columnsGastos,
    columnsCosto
  } = useTableColumnsRegistroFacturas()
  //hook
  const {
    pagination,
    setPagination,
    globalFilter,
    //setGlobalFilter,
    onChangeFilter,
    searchTerm,
    //cleanFilter,
  } = useTableFilter()
  const { pageIndex, pageSize } = pagination
  const {
    columnFilters,
    setColumnFilters,
    filterObject
  } = useTableServerSideFiltering()

  const form = useForm({
    defaultValues: {
      tipo_producto: "",
      categoria_producto: ""
    }
  })
  const { } = form
  ///
  const {
    data: categoriaProductoResp,
    isLoading: isLoadingCategoriaProducto
  } = useFetchCategoryProduct({
    page_size: 600
  })

  const tipoOptions = Object.values(TipoProductoEnumChoice).filter(value => value !== 'VENTAS' && value !== 'ACTIVOS')
    .map(value => ({
      key: value,
      label: value
    }));

  //FETCH
  const {
    data: dataProductos,
    isLoading: isLoadingProductos,
    isRefetching: isRefetchingProducto
  } = useFetchProductos({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      tipo_producto: catalogo,
      categoria_producto: selectedCategory,
      descripcion: searchTerm.toUpperCase(),
      ...filterObject,
      filterByState: false
    }
  })
  //gastos
  const {
    data: dataGastos,
    isLoading: isLoadingGastos,
    isRefetching: isRefetchingGasto
  } = useFetchGastos({
    page_size: 600
  })
  //costos
  const {
    data: dataCostos,
    isLoading: isLoadingCostos,
    isRefetching: isRefetchingCostos
  } = usefetchCostos({
    page_size: 600
  })
  //handle-catalogos
  const handleCatalogos = (e: string) => {
    setCatalogo(e)
    form.setValue('categoria_producto', '')
    setSelectedCategory("")
  }
  //hadle_selected_product
  const onChangeAux = (e: any) => {
    console.log('product_selecyt', e)
    onChange?.(e!)
  }
  ///
  /* const onChangeGasto = (e: any) => {
    console.log('gasto', e)
  } */
  //
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => {
          setIsOpen(true)
        }}
      >
        {'AGREGAR PRODUCTOS'}
      </Button>

      <ScrollableDialogProps
        open={isOpen}
        title="PRODUCTOS"
        onCloseIcon={() => setIsOpen(false)}
        minWidth="70%"
        contentNode={
          <>
            <Grid item {...gridSize}>
              <Paper className="paper-producto">
                <Grid container spacing={2} alignItems={"center"}>
                  
                  <Grid item {...gridSizeMdLg4}>
                    <SearchComponente
                      value={globalFilter}
                      text="por descripcion"
                      onChange={onChangeFilter}
                    />
                  </Grid>

                  <Grid item {...gridSizeMdLg4}>
                    <CustomAutocomplete
                      label="Catalogos Productos"
                      name="catalogo"
                      options={tipoOptions}
                      isLoadingData={false}
                      valueKey={"key"}
                      //actualValueKey={"codigo"}
                      defaultValue={''}
                      control={form.control}
                      error={undefined}
                      helperText={undefined}
                      onChangeValue={e => {
                        handleCatalogos(e)
                      }}
                    />
                  </Grid>
                  {catalogo === TipoProductoEnumChoice.INVENTARIABLE && (
                    <Grid item {...gridSizeMdLg4}>
                      <CustomAutocomplete<CATEGORYPRODUCT>
                        label="Categoria Producto"
                        name="categoria_producto"
                        options={categoriaProductoResp?.data.data || []}
                        isLoadingData={isLoadingCategoriaProducto}
                        valueKey={"nombre"}
                        actualValueKey={"codigo"}
                        defaultValue={form.getValues().categoria_producto || ''}
                        control={form.control}
                        error={undefined}
                        helperText={undefined}
                        onChangeValue={e => {
                          setSelectedCategory(e)
                        }}
                      />
                    </Grid>
                  )}

                </Grid>
                <div className="linea" />
                <Grid item xs={12}>
                  {(catalogo === TipoProductoEnumChoice.INVENTARIABLE) && form.getValues().categoria_producto && (
                    <GeneralTable
                      columns={columnsSelectProductoModal}
                      data={dataProductos?.data.data || []}
                      isLoading={isLoadingProductos}
                      isRefetching={isRefetchingProducto}
                      enableGlobalFilter={false}
                      pagination={pagination}
                      onPaging={setPagination}
                      rowCount={dataProductos?.data.count}
                      columnFilters={columnFilters}
                      onColumnFiltersChange={setColumnFilters}
                      enableManualFiltering={true}
                      enableSorting={false}
                      //
                      canEdit={false}
                      canAdd={true}
                      onAdd={e => {
                        onChangeAux(e)
                      }}
                    />
                  )}
                  {(catalogo === TipoProductoEnumChoice.GASTOS) && (
                    <GeneralTable
                      columns={columnsGastos}
                      data={dataGastos?.data.data || []}
                      isLoading={isLoadingGastos}
                      isRefetching={isRefetchingGasto}
                      enableGlobalFilter={false}
                      pagination={pagination}
                      onPaging={setPagination}
                      rowCount={dataGastos?.data.count}
                      columnFilters={columnFilters}
                      onColumnFiltersChange={setColumnFilters}
                      enableManualFiltering={true}
                      enableSorting={false}
                      //
                      canEdit={false}
                      canAdd={true}
                      onAdd={e => {
                        onChangeAux(e)
                      }}

                    />
                  )}
                  {(catalogo === TipoProductoEnumChoice.COSTOS) && (
                    <GeneralTable
                      columns={columnsCosto}
                      data={dataCostos?.data.data || []}
                      isLoading={isLoadingCostos}
                      isRefetching={isRefetchingCostos}
                      enableGlobalFilter={false}
                      pagination={pagination}
                      onPaging={setPagination}
                      rowCount={dataCostos?.data.count}
                      columnFilters={columnFilters}
                      onColumnFiltersChange={setColumnFilters}
                      enableManualFiltering={true}
                      enableSorting={false}
                      //
                      canEdit={false}
                      canAdd={true}
                      onAdd={e => {
                        onChangeAux(e)
                      }}
                    />
                  )}

                </Grid>

              </Paper>

            </Grid>
          </>
        }
      />
    </>
  )
}